import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { FC } from 'react'

type Props = {
    value: boolean
    onChange?: (event: React.MouseEvent<HTMLElement, MouseEvent>, value: boolean | null) => void
}

export const SwitcherCalendar: FC<Props> = ({ value, onChange }) => {
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={onChange}
            sx={{
                height: '32px',
                '& > button': {
                    padding: '6px 14px',
                    color: '#1B1C1D !important',
                    borderColor: '#E5E5E7 !important',

                    ':hover': {
                        backgroundColor: '#F6F6F6',
                    },
                },

                '& > button:first-of-type': {
                    borderRadius: '32px 0 0 32px',
                },
                '& > button:last-of-type': {
                    borderRadius: '0 32px 32px 0',
                },

                '& .Mui-selected:not(:hover)': {
                    backgroundColor: '#EBF5FD !important',
                },
                '& .Mui-selected:hover': {
                    backgroundColor: '#F6F6F6 !important',
                },
            }}>
            <ToggleButton value={true}>Неделя</ToggleButton>
            <ToggleButton value={false}>Месяц</ToggleButton>
        </ToggleButtonGroup>
    )
}
